import {Analytics} from "./Analytics";
import {AnalyticsConfig} from "./AnalyticsConfig";

const cfg: AnalyticsConfig = (window as any).verifiedPayCfg || {};
new Analytics(cfg);